<template>
  <div>

    <a-layout-content :style="{ margin: '0px 0px 0' }">
      <div :style="{ padding: '1px', background: '#fff', minHeight: '10px' ,padding: '8px'}">
        <div :style="{fontSize: '12px'}">
          <a-space direction="horizontal" align="start">
            <a-textarea :placeholder="$t('message.views.scItemView.itemCode')"
                        :auto-size="{ minRows: 1, maxRows: 3 }" id="itemCode" allow-clear
                        :style="{width: '300px'}"
                        @change="onItemCodeChange"/>

            <a-textarea :placeholder="$t('message.views.scItemView.barcode')" id="barcode" allow-clear
                        :style="{width: '300px'}"
                        @change="onBarcodeChange" :auto-size="{ minRows: 1, maxRows: 3 }"/>
            <br>
            <!--$t('message.views.workbench.activityResult')-->
            <a-select :style="{width: '400px' }" allow-clear
                      @change="onTableSearchShopChange"
                      :placeholder="$t('message.views.scItemView.mainShop')" required="true">
              <a-select-option v-for="shopSelectValue in this.tableShopSelectValues"
                               :key="shopSelectValue.key+'-'+shopSelectValue.site">
                {{'('+shopSelectValue.key+')'+shopSelectValue.name}}
              </a-select-option>
            </a-select>
            <a-button type="primary" icon="search" allow-clear @click="onSearch">
              {{$t('message.views.scItemView.searchButton')}}
            </a-button>
            <a-dropdown>
              <a-menu @click="handleExportClick" slot="overlay">
                <a-menu-item key="export">Export</a-menu-item>
              </a-menu>
              <a-button>
                {{$t('message.views.scItemView.fileExport')}}
                <a-icon type="down"/>
              </a-button>
            </a-dropdown>
          </a-space>

        </div>

      </div>
    </a-layout-content>
    <div>
      <export-alert ref="exportAlert"></export-alert>
    </div>
    <a-table :columns=columns :data-source="data" :scroll="{ x: 1000 }"
             :style="{background: '#fff' }"
             :loading="mainTableLoading"
             @expand="onExpand" :pagination="pagination">
      <a-table
        slot="expandedRowRender"
        slot-scope="record"
        :columns="innerColumns"
        :data-source="innerData[record.scItemId]"
        :pagination="false"
        :loading="subListLoading"
        :rowClassName="function(record, index){let className = 'twoe';if (index % 2 === 1) className = 'one';return className;}"
        size="small"
        :style="{background: '#ffffff' }">
        <template slot="innerImage" slot-scope="text, record">
          <a-popover trigger="hover">
            <template slot="content">
              <img :src="record.itemMajorImageUrl" style="width: 250px"/>
            </template>
            <img :src="record.itemMajorImageUrl" style="width: 50px"/>
          </a-popover>
        </template>
        <a slot="pdp" slot-scope="text,record" @click="pdpUrl(record.pdp)">{{record.innerId}}</a>

        <template slot="Operation" slot-scope="text, record">

          <a @click="subDetailRelation(record)">
            <a-tooltip>
              <template slot="title">
                {{$t('message.views.scItemView.platformSkuDetail')}}
              </template>
              <a-icon type="file-search" style="fontSize:18px"/>
            </a-tooltip>
          </a>
          <a-popconfirm
            v-if="data.length"
            :title="$t('message.views.scItemView.sureDelete')"
            @confirm="subDeleteRelation(record)"
          >
            <a-tooltip>
              <template slot="title">
                {{$t('message.views.scItemView.deleteRelatedPlatformSku')}}
              </template>
              <a-icon type="close-square" style="fontSize:18px;  color:dodgerblue"/>
            </a-tooltip>
          </a-popconfirm>
        </template>

      </a-table>
      <template slot="Detail" slot-scope="text, record">
        <a @click="showDrawer(record.scitemMerchantCode,record.scItemId)">
          <a-tooltip>
            <template slot="title">
              <span></span>
              {{$t('message.views.scItemView.fulfillmentSkuDetail')}}
            </template>
            <a-icon type="file-search" style="fontSize:18px"/>
          </a-tooltip>
        </a>
        <a v-show="record.scitemTenantId == 117000"
           @click="showItemSearchDrawer(record.scitemMerchantCode,record.scitemTenantId,record.scItemId,record.cbShipperId,record.shipperId)">
          <a-tooltip>
            <template slot="title">
              {{$t('message.views.scItemView.addRelatedPlatformSku')}}
            </template>
            <a-icon type="plus-square" style="fontSize:18px"/>
          </a-tooltip>
        </a>
        <a @click="showItemRelationRecordDrawer(record.scItemId)">
          <a-tooltip>
            <template slot="title">
              {{$t('message.views.scItemView.showRelation')}}
            </template>
            <a-icon type="eye" style="fontSize:18px"/>
          </a-tooltip>
        </a>
      </template>
      <span slot="tag" slot-scope="text,record">
        <a-tag :color="record.scitemMerchantCode === 'LAZADA' ? '#7800ff' :  '#2db7f5'">
        {{ record.scitemMerchantCode }}
        </a-tag>
      </span>
      <template slot="shop" slot-scope="text,record">
        <p style="margin: 1px; ">{{ record.shopName }}</p>
        <p style="color: darkgrey;margin: 1px ">{{ record.shipperId }}</p>
      </template>
      <template slot="footer" slot-scope="currentPageData">

      </template>
    </a-table>

    <a-drawer width="680" placement="right" :closable="true" :visible="visible" @close="onClose"
              style="font-weight: bold">
      <template>
        <div>
          <p style="fontSize: 14px;color: rgba(0, 0, 0, 0.85); marginBottom: 16px;fontWeight: 500">
            {{$t('message.views.scItemView.fulfillmentTitle')}} :{{scItemTitle}}
          </p>

          <a-divider/>
          <a-descriptions bordered :title="$t('message.views.scItemView.basicInfo')" :size="size">
            <a-descriptions-item :label="$t('message.views.scItemView.barcode')" span="5">
              {{scItemBarcodes}}
            </a-descriptions-item>
            <a-descriptions-item :label="$t('message.views.scItemView.itemCode')" span="5">
              {{scItemCode}}
            </a-descriptions-item>
            <a-descriptions-item :label="$t('message.views.scItemView.scItemMerchant')" span="5">
              {{scItemMerchant}}
            </a-descriptions-item>
            <a-descriptions-item :label="$t('message.views.scItemView.mainShop')" span="5">
              {{scItemShipperId}}
            </a-descriptions-item>
          </a-descriptions>
          <a-divider/>
          <a-descriptions :title="$t('message.views.scItemView.manufacturePackageDimensions')" :size="size">
            <p style="fontSize: 14px;color: rgba(0, 0, 0, 0.85); marginBottom: 16px;fontWeight: 500">
              {{$t('message.views.scItemView.length')}}: {{scItemLength}}
            </p>
            <p style="fontSize: 14px;color: rgba(0, 0, 0, 0.85); marginBottom: 16px;fontWeight: 500">
              {{$t('message.views.scItemView.width')}}: {{scItemWidth}}
            </p>
            <p style="fontSize: 14px;color: rgba(0, 0, 0, 0.85); marginBottom: 16px;fontWeight: 500">
              {{$t('message.views.scItemView.height')}}: {{scItemHeight}}
            </p>
            <p style="fontSize: 14px;color: rgba(0, 0, 0, 0.85); marginBottom: 16px;fontWeight: 500">
              {{$t('message.views.scItemView.weight')}}: {{scItemWeight}}
            </p>
          </a-descriptions>
          <a-divider/>
          <a-descriptions :title="$t('message.views.scItemView.logisticsAttributes')" :size="size">
            <div>
              <p style="fontSize: 14px;color: rgba(0, 0, 0, 0.85); marginBottom: 16px;fontWeight: 500">
                {{$t('message.views.scItemView.productType')}}
                <a-select :style="{width: '200px' }" @change="onScItemProductTypeChange" :key = "scItemProductType" :default-value= "scItemProductType">
                  <a-select-option v-for="productTypeSelectValue in this.productTypeSelectValues" :key="productTypeSelectValue">
                    {{productTypeSelectValue}}
                  </a-select-option>
                </a-select>
              </p>

              <p style="fontSize: 14px;color: rgba(0, 0, 0, 0.85); marginBottom: 16px;fontWeight: 500">
                {{$t('message.views.scItemView.temperatureCondition')}}
                <a-select :style="{width: '200px' }" @change="onScItemTemperatureConditionChange" :key = "scItemTemperatureCondition" :default-value= "scItemTemperatureCondition">
                  <a-select-option v-for="temperatureConditionSelectValue in this.temperatureConditionSelectValues" :key="temperatureConditionSelectValue">
                    {{temperatureConditionSelectValue}}
                  </a-select-option>
                </a-select>
              </p>


              <p style="fontSize: 14px;color: rgba(0, 0, 0, 0.85); marginBottom: 16px;fontWeight: 500">
                {{$t('message.views.scItemView.serialNumberManagement')}}
                <a-select :style="{width: '200px' }"  @change="onScItemSerialNumberManagementChange" :key = "scItemSerialNumberManagement" :default-value= "scItemSerialNumberManagement">
                  <a-select-option v-for="scItemSerialNumberManagementSelectValue in this.scItemSerialNumberManagementSelectValues" :key="scItemSerialNumberManagementSelectValue">
                    {{scItemSerialNumberManagementSelectValue}}
                  </a-select-option>
                </a-select>
              </p>

              <p style="fontSize: 14px;color: rgba(0, 0, 0, 0.85); marginBottom: 16px;fontWeight: 500">
                {{$t('message.views.scItemView.shelfLifeManagement')}}
                <a-select :style="{width: '200px' }"  @change="onScItemShelfLifeManagementChange" :key="scItemShelfLifeManagement" :default-value= "scItemShelfLifeManagement">
                  <a-select-option v-for="scItemShelfLifeManagementSelectValue in this.scItemShelfLifeManagementSelectValues" :key="scItemShelfLifeManagementSelectValue">
                    {{scItemShelfLifeManagementSelectValue}}
                  </a-select-option>
                </a-select>
              </p>

<!--            <a-descriptions-item :label="$t('message.views.scItemView.productType')" span="2">-->
<!--              {{scItemProductType}}-->
<!--            </a-descriptions-item>-->
<!--            <a-descriptions-item :label="$t('message.views.scItemView.temperatureCondition')" span="2"-->
<!--                                 style="font-weight: bolder">-->
<!--              {{scItemTemperatureCondition}}-->
<!--            </a-descriptions-item>-->
<!--            <a-descriptions-item :label="$t('message.views.scItemView.serialNumberManagement')" span="2">-->
<!--              {{scItemSerialNumberManagement}}-->
<!--            </a-descriptions-item>-->
<!--            <a-descriptions-item :label="$t('message.views.scItemView.shelfLifeManagement')" span="2">-->
<!--              {{scItemShelfLifeManagement}}-->
<!--            </a-descriptions-item>-->
            <a-button type="primary"  @click="submitUpdateScItem">
              {{$t('message.views.scItemView.updateScItemButton')}}
            </a-button>
            </div>
          </a-descriptions>
        </div>
      </template>
    </a-drawer>
      <br>
      <a-drawer width="1200" placement="right" :closable="true" :visible="itemRelationVisible"
                @close="onRelationRecordClose"
                style="font-weight: bold">
        <a-table
          :columns="relationColumns"
          :data-source="RelationRecordValues"
          :loading="relationRecordLoading"
          :pagination="paginationRelationRecord"
          size="small"
          :style="{background: '#ffffff' }"
          >
          <template slot="innerImage" slot-scope="text, record">
            <a-popover trigger="hover">
              <template slot="content">
                <img :src="record.itemMajorPictureUrl" style="width: 250px"/>
              </template>
              <img :src="record.itemMajorPictureUrl" style="width: 50px"/>
            </a-popover>
          </template>

          <template slot="Operation" slot-scope="text, record">

            <a @click="subDetailRelation(record)">
              <a-tooltip>
                <template slot="title">
                  {{$t('message.views.scItemView.platformSkuDetail')}}
                </template>
                <a-icon type="file-search" style="fontSize:18px"/>
              </a-tooltip>
            </a>
          </template>
          <template slot="Status" slot-scope="text, record">
<!--              <a-tooltip v-if = "RelationRecordValues.length && record.status !== 1">-->
<!--                <template slot="title">-->
<!--                  {{$t('message.views.scItemView.deleteRelatedPlatformSku')}}-->
<!--                </template>-->
<!--                <a-icon type="close-square" style="fontSize:18px;  color:dodgerblue"/>-->
<!--              </a-tooltip>-->
<!--              <a-tooltip v-if = "RelationRecordValues.length && record.status === 1">-->
<!--                <template slot="title">-->
<!--                  {{$t('message.views.scItemView.bindRelatedPlatformSku')}}-->
<!--                </template>-->
<!--                <a-icon type="plus-circle" style="fontSize:18px;  color:dodgerblue"/>-->
<!--              </a-tooltip>-->
                <p v-if = "RelationRecordValues.length && record.status !== 1">
                    {{$t('message.views.scItemView.deleteRelatedPlatformSku')}}
                </p>
                <p v-if = "RelationRecordValues.length && record.status === 1">
                    {{$t('message.views.scItemView.bindRelatedPlatformSku')}}
                </p>
          </template>

        </a-table>
      </a-drawer>

    <a-drawer width="1200" placement="right" :closable="true" :visible="itemSearchAeVisible"
              @close="onItemSearchAeClose"
              style="font-weight: bold">
      <template>
        <a-layout-content :style="{ margin: '0px 0px 0' }">
          <div :style="{ padding: '1px', background: '#fff', minHeight: '10px' ,padding: '8px'}">
            <div :style="{fontSize: '12px'}">
              {{$t('message.views.scItemView.shop')}}:
              <a-select style="width: 650px " @change="onItemSearchAeShopChange" allow-clear :value="shopAeFocusValue"
                        :placeholder="$t('message.views.scItemView.mainShop')" >
                <a-select-option v-for="shopSelectValue in this.shopAeSelectValues"
                                 :key="shopSelectValue.key+'-'+shopSelectValue.site">
                  {{'('+shopSelectValue.key+')'+shopSelectValue.name}}
                </a-select-option>
              </a-select>
              <br>
              {{$t('message.views.scItemView.platformTitle')}}:
              <a-input :placeholder="$t('message.views.scItemView.platformTitle')" id="itemAeTitle" allow-clear
                       :style="{width: '240px',margin: '10px'}"
                       @change="onItemSearchAeTitleChange"/>
              {{$t('message.views.scItemView.itemId')}}:
              <a-input :placeholder="$t('message.views.scItemView.itemId')" id="ItemId" allow-clear
                       :style="{width: '265px',margin: '10px'}"
                       @change="onItemSearchAeItemIdChange"/>
              <br>
              <a-button type="primary" :style="{width:'80px' ,margin: '5px'}" @click="onItemAeSearch">
                {{$t('message.views.scItemView.searchButton')}}
              </a-button>
            </div>
          </div>
        </a-layout-content>
        <div>
          <div style="margin-bottom: 16px">
            <span style="margin-left: 8px">
              <template v-if="hasAeSelected">
                {{ `Selected ${itemAeSelectedRowKeys.length} items` }}
              </template>
            </span>
          </div>
          <a-table
            @expand="onAeSkuList"
            :columns="itemAeSearchColumns"
            :data-source="itemAeSearchdata"
            :loading="loading"
            row-key="itemId"
            :pagination="paginationAeItem">
            <a-table
              slot="expandedRowRender"
              slot-scope="record"
              :row-selection="{ selectedRowKeys: itemAeSelectedRowKeys
                ,type:'radio'
                ,onChange: onAeSelectChange
                ,getCheckboxProps:checkBoxProps
                ,selections: false}"
              :columns="innerAeSkuColumns"
              :data-source="innerAeSkuData.get(record.itemId)"
              :pagination="false"
              :loading="aeLoading"
              :style="{background: '#DCDCDC' }">

            </a-table>
          </a-table>
        </div>
      </template>
      <a-button type="primary" :style="{width:'25' ,margin: '5px' ,background:'rgb(255 121 0)' ,border:'0px'}"
                @click="onAeItemBind">Bind
      </a-button>
      <a-button type="primary" :disabled="!hasAeSelected" :loading="itemAeSearchloading" @click="aeStart">
        {{$t('message.views.scItemView.reload')}}
      </a-button>
    </a-drawer>

    <a-drawer width="680" placement="right" :closable="true" :visible="subVisible" @close="onSubClose"
              style="font-weight: bold">

      <template>
        <div>
          <p style="fontSize: 14px;color: rgba(0, 0, 0, 0.85); marginBottom: 16px;fontWeight: 500">
            {{$t('message.views.scItemView.platformTitle')}}:{{platformTitle}}
          </p>

          <a-divider/>
          <a-descriptions bordered :title="$t('message.views.scItemView.basicInfo')" :size="size">
            <a-descriptions-item :label="$t('message.views.scItemView.shop')" span="3">
              {{platformShopName}}
            </a-descriptions-item>
            <a-descriptions-item :label="$t('message.views.scItemView.sellerSku')" span="3">
              {{platformSellerSKU}}
            </a-descriptions-item>
            <a-descriptions-item :label="$t('message.views.scItemView.merchant')" span="3">
              {{platformMerchant}}
            </a-descriptions-item>
            <a-descriptions-item :label="$t('message.views.scItemView.status')" span="3">
              {{productStatus}}
            </a-descriptions-item>
            <a-descriptions-item :label="$t('message.views.scItemView.skuStatus')" span="3">
              {{platformStatus}}
            </a-descriptions-item>
            <a-descriptions-item :label="$t('message.views.scItemView.platformSku')" span="3">
              {{platformSku}}
            </a-descriptions-item>
            <a-descriptions-item :label="$t('message.views.scItemView.category')" span="3">
              {{platformCategory}}
            </a-descriptions-item>
            <a-descriptions-item :label="$t('message.views.scItemView.brand')" span="3">
              {{platformBrand}}
            </a-descriptions-item>
          </a-descriptions>
          <a-divider/>

          <a-space align="center">
            <a-button type="primary" ghost allow-clear :style="{display:this.upShow}" @click="upShelf">
              {{$t('message.views.scItemView.upShelf')}}
            </a-button>
            <a-button type="danger" ghost allow-clear :style="{display:this.downShow}" @click="downShelf">
              {{$t('message.views.scItemView.downShelf')}}
            </a-button>
          </a-space>
          <a-divider/>
        </div>
      </template>
      <template>
        <a-carousel dots-class="slick-dots slick-thumb" style="width: 420px">
          <img :src="this.platformMainImage" style="width: 400px"/>
        </a-carousel>
      </template>
    </a-drawer>
  </div>
</template>

<script>

  import request from '../../utils/request'

  const itemSearchdata = []

  export default {
    created () {
      request({
        url: '/shipper/mainShop',
        method: 'get'
      }).then(response => {
        var shops = response.data.data
        this.cbShipperId = shops[0].cbShipperId
        for (let shopIndex = 0; shopIndex < shops.length; shopIndex++) {
          this.tableShopSelectValues[shopIndex] = {
            key: shops[shopIndex].shipperId,
            name: shops[shopIndex].shopName,
            site: shops[shopIndex].tenantGroup
          }
        }
      })
      this.getTableData()
    },
    computed: {
      checkBoxProps (record) {
        // console.log(JSON.stringify(record))
        return record => ({
          props: {
            disabled: record.bind == true // Column configuration not to be checked
          }
        })
      },

      hasAeSelected () {
        return this.itemAeSelectedRowKeys.length > 0
      },
      innerAeSkuColumns () {
        return [
          {
            title: this.$t('message.views.scItemView.platformSku'),
            dataIndex: 'groupUniCode',
            key: 'groupUniCode',
            width: 250
          },
          {
            title: this.$t('message.views.scItemView.sellerSku'),
            dataIndex: 'sellerUniCode',
            key: 'sellerUniCode',
            width: 200
          },
          {
            title: this.$t('message.views.scItemView.itemId'),
            dataIndex: 'itemId',
            key: 'itemId',
            width: 200
          },
          {
            title: this.$t('message.views.scItemView.skuId'),
            dataIndex: 'skuId',
            key: 'skuId',
            width: 200
          },
          {
            title: this.$t('message.views.scItemView.shop'),
            key: 'sellerId',
            dataIndex: 'sellerId',
            width: 200
          }
        ]
      },

      columns () {
        return [
          {
            dataIndex: 'scItemTitle',
            key: 'scItemTitle',
            title: this.$t('message.views.scItemView.fulfillmentTitle'),
            width: 180
          },
          {dataIndex: 'itemCode', key: 'itemCode', title: this.$t('message.views.scItemView.itemCode'), width: 100},
          {dataIndex: 'barcodes', key: 'barcodes', title: this.$t('message.views.scItemView.barcode'), width: 100},
          {
            dataIndex: 'shipperId',
            key: 'shipperId',
            title: this.$t('message.views.scItemView.mainShop'),
            width: 100,
            scopedSlots: {customRender: 'shop'}
          },
          {
            dataIndex: 'scitemMerchantCode',
            key: 'scitemMerchantCode',
            title: this.$t('message.views.scItemView.scItemMerchant'),
            width: 100,
            scopedSlots: {customRender: 'tag'}
          },
          {
            title: this.$t('message.views.scItemView.operation'),
            dataIndex: '',
            key: 'x',
            scopedSlots: {customRender: 'Detail'},
            width: 100
          }
        ]
      },
      innerColumns () {
        return [
          {
            dataIndex: 'innerImage',
            key: 'innerImage',
            title: '',
            scopedSlots: {customRender: 'innerImage'},
            width: 40
          },
          {
            dataIndex: 'itemTitle',
            key: 'itemTitle',
            title: this.$t('message.views.scItemView.platformTitle'),
            width: 180
          },
          {dataIndex: 'sellerSku', key: 'sellerSku', title: this.$t('message.views.scItemView.sellerSku'), width: 100},
          {
            dataIndex: 'innerId',
            key: 'innerId',
            title: this.$t('message.views.scItemView.platformSku'),
            width: 100,
            scopedSlots: {customRender: 'pdp'}
          },
          {dataIndex: 'shopName', key: 'shopName', title: this.$t('message.views.scItemView.shop'), width: 100},
          {dataIndex: 'site', key: 'site', title: this.$t('message.views.scItemView.itemSite'), width: 80},
          {
            title: this.$t('message.views.scItemView.operation'),
            dataIndex: '',
            key: 'x',
            scopedSlots: {customRender: 'Operation'},
            width: 120
          }
        ]
      },
      relationColumns () {
        return [
          {
            dataIndex: 'innerImage',
            key: 'innerImage',
            title: '',
            scopedSlots: {customRender: 'innerImage'},
            width: 40
          },
          {
            dataIndex: 'itemTitle',
            key: 'itemTitle',
            title: this.$t('message.views.scItemView.platformTitle'),
            width: 180
          },
          {dataIndex: 'sellerSku', key: 'sellerSku', title: this.$t('message.views.scItemView.sellerSku'), width: 100},
          {dataIndex: 'shopName', key: 'shopName', title: this.$t('message.views.scItemView.shop'), width: 100},
          {dataIndex: 'itemSite', key: 'itemSite', title: this.$t('message.views.scItemView.itemSite'), width: 80},
          {
            dataIndex: 'gmtModified',key: 'gmtModified', title: this.$t('message.views.scItemView.gmtModified'),width: 80
          },
          {
            title: this.$t('message.views.scItemView.operation'),
            dataIndex: '',
            key: 'x',
            scopedSlots: {customRender: 'Operation'},
            width: 60
          },
          {
            title: this.$t('message.views.scItemView.status'),
            dataIndex: '',
            key: 'x',
            scopedSlots: {customRender: 'Status'},
            width: 60
          }
        ]
      },
      itemAeSearchColumns () {
        return [
          {title: this.$t('message.views.scItemView.platformTitle'), dataIndex: 'title', key: 'title', width: 250},
          {title: this.$t('message.views.scItemView.itemId'), dataIndex: 'itemId', key: 'itemId', width: 200}
        ]
      }
    },
    watch: {
      shopAeFocusValue(val) {
        console.log(`selected:`, val);
      },
    },
    data () {
      return {
        upShow: 'none',
        downShow: 'none',
        mainTableLoading: false,
        subListLoading: false,
        itemSearchloading: false,
        selectShop: [],
        itemSelectedRowKeys: [],
        visible: false,
        subVisible: false,
        itemSearchVisible: false,
        pStyle: {
          fontSize: '14px',
          color: 'rgba(0,0,0,0.85)',
          lineHeight: '20px',
          display: 'block',
          marginBottom: '16px'
        },
        pStyle2: {
          marginBottom: '24px'
        },
        current: ['scItem'],
        value: true,
        data: null,
        size: 'small',
        itemSearchdata,
        editVisible: false,
        startEdit: true,
        innerData: {},
        inputShopNameValue: null,
        inputBarcodeValue: null,
        inputPlatformSkuValue: null,
        inputSellerIdValue: null,
        inputShipperIdValue: null,
        inputItemCodeValue: null,
        inputCbShipperIdValue: null,
        pagination: {
          defaultPageSize: 10,
          current: 1,
          pageSize: 10,
          total: 0,
          onChange: current => {
            this.pagination.current = current
            this.getTableData()
          }
        },
        tableShopSelectValues: [],
        productTypeSelectValues: ["food","liquid","danger","other"],
        temperatureConditionSelectValues: ["Ambient","Cold","Freeze"],
        scItemSerialNumberManagementSelectValues:["true","false"],
        scItemShelfLifeManagementSelectValues:["true","false"],
        temperatureConditionNumber:null,
        paginationItem: {
          defaultPageSize: 10,
          current: 1,
          pageSize: 10,
          total: 0,
          onChange: current => {
            this.paginationItem.current = current
            this.onItemSearch()
          }
        },
        paginationAeItem: {
          defaultPageSize: 10,
          current: 1,
          pageSize: 10,
          total: 0,
          onChange: current => {
            this.paginationAeItem.current = current
            this.onItemAeSearch()
          }
        },
        paginationRelationRecord: {
          defaultPageSize: 10,
          current: 1,
          pageSize: 10,
          total:0,
          onChange: current => {
            this.paginationRelationRecord.current = current
            this.showItemRelationRecordDrawer(this.RelationFocusScItemId)
          }
        },
        scItemTitle: null,
        scItemBarcodes: null,
        scItemCode: null,
        scItemMerchant: null,
        scItemShipperId: null,
        scItemLength: null,
        scItemWidth: null,
        scItemHeight: null,
        scItemWeight: null,
        scItemProductType: null,
        scItemTemperatureCondition: null,
        scItemSerialNumberManagement: null,
        scItemShelfLifeManagement: null,
        scItemDetailId:null,
        scItemDetailBarcodesList:null,
        relationRecordFocus:null,
        platformTitle: null,
        platformMainImage: null,
        platformShopName: null,
        platformSellerSKU: null,
        platformMerchant: null,
        productStatus: null,
        platformStatus: null,
        platformSku: null,
        platformCategory: null,
        platformBrand: null,
        tableSearchShop: null,
        onFocusScItemId: null,
        onFocusScItemTenantId: null,
        onFocusCbShipperId: null,
        onFocusScitemMerchantCode: null,
        onFocusShipperId: null,
        shopSelectValues: [],
        shopSelectSite: null,
        RelationRecordValues: [],
        RelationFocusScItemId:null,
        itemRelationVisible : false,
        tableShopSelectSite: null,
        itemSearchAeVisible: false,
        shopAeFocusValue:[],
        shopAeSelectValues: [],
        itemAeSearchdata: [],
        itemSearchAeShop: null,
        itemSearchAeItemId: null,
        itemSearchAeTitle: null,
        itemAeSearchloading: false,
        itemAeSelectedKeyMap: new Map(),
        itemAeSelectedRowKeys: [],
        shopSelectAeSite: null,
        aeLoading: false,
        relationRecordLoading :false,
        innerAeSkuData: new Map(),
        productImport: {
          sellerId: null
        },
        productExport: {
          shipperId: null,
          cbShipperId: null
        },
        cbShipperId: null,
        upDownBody: {
          sellerId: null,
          itemId: null,
          skuId: null,
          site: null
        }
      }
    },
    methods: {
      getTableData () {
        this.mainTableLoading = true
        request({
          url: '/scitem/search/merchant',
          method: 'post',
          data: {
            pageIndex: this.pagination.current,
            pageSize: this.pagination.pageSize,
            userIds: this.tableSearchShop == null || this.tableSearchShop == '' ? [] : [this.tableSearchShop],
            barcodes: this.inputBarcodeValue == null ? [] : this.inputBarcodeValue,
            itemCodes: this.inputItemCodeValue == null ? [] : this.inputItemCodeValue
          }
        }).catch(error => {
          console.log('exception:' + JSON.stringify(error))
          this.mainTableLoading = false
        }).then(response => {
          this.data = response.data.result
          const pagination = {...this.pagination}
          pagination.total = parseInt(response.data.total)
          this.pagination = pagination
          this.mainTableLoading = false
        })

      },
      onList (scItemId) {
        this.subListLoading = true
        this.innerData[scItemId] = null
        request({
          url: '/item/listItem?scItemId=' + scItemId,
          method: 'get'
        }).catch(exception => {
          this.subListLoading = false
        }).then(response => {
          this.innerData[scItemId] = response.data.data
          console.log(JSON.stringify(this.innerData))
          const pagination = {...this.pagination}
          this.pagination = pagination
          this.subListLoading = false
        })

      },
      onAeSkuList (e, record) {
        this.aeLoading = true
        var itemId =  record.itemId
        var tenantId =  record.tenantId
        var tenantGroupId =  record.tenantGroupId
        var scItemId = this.onFocusScItemId
        debugger
        this.innerAeSkuData.set(itemId,[])
        console.log('onAeSkuList: ' + record.itemId, record.tenantId, record.tenantGroupId)
        console.log('this.innerAeSkuData: ' + JSON.stringify(this.innerAeSkuData))
        request({
          url: '/item/listSkuByItem/' + itemId + '?tenantId=' + tenantId + '&tenantGroupId=' +tenantGroupId+'&relatedScItemId='+scItemId,
          method: 'get'
        }).catch(exception=>{
          console.log('this.innerAeSkuData.get '+ JSON.stringify(this.innerAeSkuData.get(itemId)))
          this.aeLoading = false
        }).then(response => {
          var items = response.data.data
          const pagination = {...this.paginationAeItem}
          this.paginationAeItem = pagination
          var tempInnerAeSkuData = []
          var tempItemAeSelectedKeyMap = new Map()
          for (let i = 0; i < items.length; i++) {
            tempInnerAeSkuData.push({
              key: items[i].itemId + '-' + items[i].skuId,
              bind: items[i].bind,
              itemId: items[i].itemId,
              skuId: items[i].skuId,
              sellerId: items[i].sellerId,
              tenantGroupId: items[i].tenantGroupId,
              tenantId: items[i].tenantId,
              groupUniCode: items[i].groupUniCode,
              sellerUniCode: items[i].sellerUniCode
            })
            tempItemAeSelectedKeyMap.set(items[i].itemId + '-' + items[i].skuId, {
              itemId: items[i].itemId,
              bind: items[i].bind,
              skuId: items[i].skuId,
              sellerId: items[i].sellerId,
              tenantGroupId: items[i].tenantGroupId,
              tenantId: items[i].tenantId,
              groupUniCode: items[i].groupUniCode,
              sellerUniCode: items[i].sellerUniCode
            })
          }
          debugger

          this.itemAeSelectedKeyMap = tempItemAeSelectedKeyMap
          this.innerAeSkuData.set(itemId,tempInnerAeSkuData)
          this.aeLoading = false
          console.log('this.innerAeSkuData: ' + JSON.stringify(this.innerAeSkuData))

        })
      },
      upShelf () {
        request({
          url: '/item/up',
          method: 'post',
          data: {
            sellerId: this.upDownBody.sellerId,
            itemId: this.upDownBody.itemId,
            skuId: this.upDownBody.skuId,
            site: this.upDownBody.site
          }
        }).catch(error => {
          this.errorAlert(error.message)
        }).then(response => {
          var result = response.data
          if (result.success == true) {
            this.successAlert('Success')
            var record = {}
            record.site = this.upDownBody.site
            record.itemId = this.upDownBody.itemId
            record.skuId = this.upDownBody.skuId
            this.subDetailRelation(record)
          } else {
            this.warningAlert(result.errorMsg + '[' + result.errorCode + ']')
          }
        })
      },
      downShelf () {
        request({
          url: '/item/down',
          method: 'post',
          data: {
            sellerId: this.upDownBody.sellerId,
            itemId: this.upDownBody.itemId,
            skuId: this.upDownBody.skuId,
            site: this.upDownBody.site
          }
        }).then(response => {
          var result = response.data
          if (result.success == true) {
            this.successAlert('Success')
            var record = {}
            record.site = this.upDownBody.site
            record.itemId = this.upDownBody.itemId
            record.skuId = this.upDownBody.skuId
            this.subDetailRelation(record)
          } else {
            this.warningAlert(result.errorMsg + '[' + result.errorCode + ']')
          }
        })
      },
      onSearch () {
        if (this.inputSortGroupValue == null) {
          this.inputSortGroupValue = true
        }
        this.pagination.current = 1
        this.getTableData()
      },
      onItemAeSearch () {
        this.itemAeSearchdata = []
        this.loading = true
        var scItemId = this.onFocusScItemId

        if(this.shopSelectAeSite==null||this.itemSearchAeShop ==null){
          this.errorAlert("please select a shop")
        }
        request({
          url: '/item/search/' + this.shopSelectAeSite+'?relatedScItemId='+scItemId,
          method: 'post',
          data: {
            sellerId: this.itemSearchAeShop,
            title: this.itemSearchAeTitle,
            itemIds: this.itemSearchAeItemId == null || this.itemSearchAeItemId == '' ? [] : [this.itemSearchAeItemId],
            pageIndex: this.paginationAeItem.current,
            pageSize: this.paginationAeItem.pageSize
          }
        }).catch(exception => {
          console.log('onItemAeSearch exception')
          this.loading = false
        }).then(response => {
          const paginationAeItem = {...this.paginationAeItem}
          paginationAeItem.total = parseInt(response.data.total)
          this.paginationAeItem = paginationAeItem

          this.itemAeSearchdata = response.data.result
          console.log('itemAeSearchdata:' + JSON.stringify(this.itemAeSearchdata))

          this.loading = false
        })
      },
      onAeItemBind () {
        var map = this.itemAeSelectedKeyMap
        var bindTargetScItemId = this.onFocusScItemId
        var bindTargetScItemTenantId = this.onFocusScItemTenantId
        var bindTargetCbShipperId = this.onFocusCbShipperId
        var bindTargetShipperId = this.onFocusShipperId
        console.log('this.itemAeSelectedKeyMap:' + map)
        this.itemAeSelectedRowKeys.forEach(key => {
          console.log('this.itemAeSelectedRowKeys:' + key)

          var selectOne = map.get(key)
          console.log(selectOne)
          request({
            url: '/relation/add',
            method: 'post',
            data: {
              itemId: selectOne.itemId,
              skuId: selectOne.skuId + '',
              sellerId: selectOne.sellerId,
              itemTenantId: selectOne.tenantId,
              tenantGroupId: selectOne.tenantGroupId,
              scItemId: bindTargetScItemId,
              scitemTenantId: bindTargetScItemTenantId,
              cbShipperId: bindTargetCbShipperId,
              shipperId: bindTargetShipperId
            }
          }).then(response => {
            if (response.data.success == true) {
              this.successAlert('Success')
              this.onList(bindTargetScItemId)
              this.onFocusShipperId = null
              this.onFocusCbShipperId = null
              this.onFocusScItemTenantId = null
              this.onFocusScItemId = null
              this.itemAeSelectedRowKeys = []
              this.onItemSearchAeClose()
              this.getTableData()
            } else {
              this.warningAlert(response.data.errorMsg + '[' + response.data.errorCode + ']')
              this.onItemSearchAeClose()
            }
          })
        })

      },

      onPlatformSkuChange (e) {
        this.inputPlatformSkuValue = e.target.value
      },
      onBarcodeChange (e) {
        if (e.target.value === '' || e.target.value === '') {
          this.inputBarcodeValue = null
        } else {
          var barcodes = e.target.value.split('\n')
          this.inputBarcodeValue = barcodes
        }
      },
      onItemCodeChange (e) {
        if (e.target.value === '' || e.target.value === '') {
          this.inputItemCodeValue = null
        } else {
          var itemCodes = e.target.value.split('\n')
          this.inputItemCodeValue = itemCodes
        }
      },
      onItemSearchAeTitleChange (e) {
        this.itemSearchAeTitle = e.target.value
      },
      onScItemProductTypeChange (e) {
        this.scItemProductType = e
      },
      onScItemTemperatureConditionChange (e) {
        if(e === "Ambient"){
          this.temperatureConditionNumber = "1"
        }else if(e === "Cold"){
          this.temperatureConditionNumber = "4"
        }else if(e === "Freeze"){
          this.temperatureConditionNumber = "6"
        }
      },
      onScItemSerialNumberManagementChange (e) {
        this.scItemSerialNumberManagement = e;
      },
      onScItemShelfLifeManagementChange (e) {
        this.scItemShelfLifeManagement = e;
      },
      submitUpdateScItem() {
        request({
          url:'/scitem/update/' + this.scItemMerchant,
          data: {
            scItemId:this.scItemDetailId,
            productType: this.scItemProductType,
            temperatureRequirement:this.temperatureConditionNumber ,
            isSnMgt:this.scItemSerialNumberManagement !== "false",
            isShelfLifeMgt:this.scItemShelfLifeManagement !== "false" ,
            barcodeList:this.scItemBarcodes,
          },
          method:'post'
        }).catch(error => {
          this.errorAlert(error.message)
        }).then(response => {
          console.log("scItemId:" + this.scItemDetailId + "productType:" + this.scItemProductType
            + "temperatureRequirement:" + this.scItemTemperatureCondition + "isSnMgt:" + this.scItemSerialNumberManagement
            + "isShelfLifeMgt:" + this.scItemShelfLifeManagement + "barcodeList:" + this.scItemBarcodes)
          if (response.data.success == true) {
            this.successAlert('Success')
          } else {
            this.warningAlert(response.data.errorMsg + '[' + response.data.errorCode + ']')
          }}
        )

      },
      onTableSearchShopChange (e) {
        if (e == null || e == '') {
          this.tableSearchShop = null
          this.tableShopSelectSite = null
        } else {
          this.tableSearchShop = e.split('-')[0]
          this.tableShopSelectSite = e.split('-')[1]
        }
      },
      onItemSearchAeItemIdChange (e) {
        this.itemSearchAeItemId = e.target.value
      },
      onItemSearchAeShopChange (e) {
        this.shopAeFocusValue = [e]
        this.itemSearchAeShop = e.split('-')[0]
        this.shopSelectAeSite = e.split('-')[1]

        console.log('itemSearchAeShop: ' + this.itemSearchAeShop)
        console.log('shopSelectAeSite: ' + this.shopSelectAeSite)

      },
      onReset () {
        this.inputShopNameValue = null,
          this.inputSellerSkuValue = null,
          this.inputPlatformSkuValue = null,
          this.innerData = null
      },
      onExpand (e, record) {
        this.onList(record.scItemId)
      },
      showDrawer (scitemMerchantCode, scItemId) {
        request({
          url: '/scitem/' + scitemMerchantCode + '/' + scItemId,
          method: 'get'
        }).then(response => {
          var scitemData = response.data.data
          console.log(JSON.stringify(scitemData))
          this.scItemTitle = scitemData.name
          this.scItemBarcodes = scitemData.barCodes.toString().replace(/[\\]\\["]/g, '')
          this.scItemCode = scitemData.userUniCode
          this.scItemMerchant = scitemData.merchantCode
          this.scItemShipperId = scitemData.userId
          this.scItemLength = scitemData.length
          this.scItemWidth = scitemData.width
          this.scItemHeight = scitemData.height
          this.scItemWeight = scitemData.weight
          this.scItemDetailId = scItemId
          var food = scitemData.features.FOOD
          var liquid = scitemData.features.LIQUID
          var isDanger = scitemData.features.ISDANGER
          var temperaturerequirement = scitemData.features.TEMPERATUREREQUIREMENT
          if (temperaturerequirement != null && temperaturerequirement == '4') {
            this.scItemTemperatureCondition = 'Cold'
          } else if (temperaturerequirement == '6') {
            this.scItemTemperatureCondition = 'Freeze'
          } else {
            this.scItemTemperatureCondition = 'Ambient'
          }

          if (food != null && food == '1') {
            this.scItemProductType = 'food'
          } else if (liquid != null && liquid == '1') {
            this.scItemProductType = 'liquid'
          } else if (isDanger != null && isDanger == 'true') {
            this.scItemProductType = 'danger'
          } else {
            this.scItemProductType = 'other'
          }
          this.scItemSerialNumberManagement = scitemData.isSnMgt == null || scitemData.isSnMgt === '' ? 'false' : scitemData.isSnMgt === false ? 'false':'true'
          this.scItemShelfLifeManagement = scitemData.isShelfLifeMgt == null || scitemData.isShelfLifeMgt === '' ? 'false' : scitemData.isShelfLifeMgt  === false ? 'false':'true'
          this.visible = true
          console.log(scitemData.features.isShelfLifeMgt + " " + scitemData.isSnMgt )
          console.log(this.scItemTemperatureCondition + this.scItemProductType + this.scItemSerialNumberManagement + this.scItemShelfLifeManagement)
        })
      },
      showItemSearchDrawer (scItemMerchantCode, scItemTenantId, scItemId, cbShipperId, shipperId) {
        this.showAeItemSearchDrawer(scItemMerchantCode, scItemTenantId, scItemId, cbShipperId, shipperId)
      },
      showAeItemSearchDrawer (scItemMerchantCode, scItemTenantId, scItemId, cbShipperId, shipperId) {
        this.onFocusScItemId = scItemId
        this.onFocusScItemTenantId = scItemTenantId
        this.onFocusScitemMerchantCode = scItemMerchantCode
        this.onFocusCbShipperId = cbShipperId
        this.onFocusShipperId = shipperId
        request({
          url: '/shipper/shops/filter?scItemId='+this.onFocusScItemId,
          method: 'get'
        }).then(response => {
          var shops = response.data.data
          for (let shopIndex = 0; shopIndex < shops.length; shopIndex++) {
            this.shopAeSelectValues.push({
              key: shops[shopIndex].sellerId,
              name: shops[shopIndex].shopName,
              site: shops[shopIndex].tenantGroup
            })
          }
          this.itemSearchAeVisible = true
        })
      },
      format(s) {
        const
          date = new Date(s),
          y = date.getFullYear(),
          m = date.getMonth() + 1,
          d = date.getDate(),
          hour = date.getHours(),
          minute = date.getMinutes(),
          second = date.getSeconds()
        return `${y}/${m < 10 ? '0'+m : m}/${d < 10 ? '0' + d : d}  ${hour < 10 ? '0'+hour : hour}:${minute < 10 ? '0' + minute : minute}:${second < 10?'0'+second : second}`
      },
      showItemRelationRecordDrawer (scItemId) {
        this.relationRecordLoading = true
        request({
          url: '/scitem/getRecord/',
          method: 'post',
          data: {
            scItemId:scItemId,
            pageIndex:this.paginationRelationRecord.current,
            pageSize:this.paginationRelationRecord.pageSize
          }
        }).then(response => {
          this.RelationRecordValues = response.data.result
          this.RelationFocusScItemId = scItemId
          this.paginationRelationRecord.total = response.data.total
          for (let index = 0; index < this.RelationRecordValues.length; index++) {
            this.RelationRecordValues[index].gmtModified = this.format(this.RelationRecordValues[index].gmtModified)
          }
          console.log(this.RelationRecordValues)
          this.itemRelationVisible = true
          this.relationRecordLoading = false
        })
      },
      aeStart () {
        this.itemAeSearchloading = true
        // ajax request after empty completing
        setTimeout(() => {
          this.itemSearchAeShop = null
          this.shopSelectAeSite = null
          this.itemAeSelectedRowKeys = []
          this.shopAeFocusValue = []
          this.shopAeSelectValues.splice(0, this.shopAeSelectValues.length)
          this.itemAeSearchloading = false
        }, 300)
      },
      onAeSelectChange (selectedRowKeys) {
        console.log(JSON.stringify(this.itemAeSelectedRowKeys))
        this.itemAeSelectedRowKeys = selectedRowKeys
      },
      onClose () {
        this.temperatureConditionNumber = null
        this.visible = false
        this.scItemTitle = null
        this.scItemBarcodes = null
        this.scItemCode = null
        this.scItemMerchant = null
        this.scItemShipperId = null
        this.scItemLength = null
        this.scItemWidth = null
        this.scItemHeight = null
        this.scItemWeight = null
        this.scItemProductType = null
        this.scItemTemperatureCondition = null
        this.scItemSerialNumberManagement = null
        this.scItemShelfLifeManagement = null
      },
      onSubClose () {
        this.upDownBody.itemId = null
        this.upDownBody.skuId = null
        this.upDownBody.sellerId = null
        this.upDownBody.site = null
        this.subVisible = false
        this.platformTitle = null
        this.platformShopName = null
        this.platformSellerSKU = null
        this.platformMerchant = null
        this.platformStatus = null
        this.productStatus = null

        this.platformSku = null
        this.platformCategory = null
        this.platformBrand = null
        this.platformMainImage = null
      },
      onRelationRecordClose() {
        this.itemRelationVisible = false
        this.RelationRecordValues = []
        this.RelationFocusScItemId = null
        this.paginationRelationRecord.current = 1
      },
      onSelectChange(selectedRowKeys,record) {
        this.relationRecordFocus = record
        console.log(record)
      },
      onItemSearchAeClose () {
        this.aeStart()
        this.shopAeFocusValue = []
        this.itemSearchAeShop = null
        this.shopSelectAeSite = null
        this.itemSearchAeVisible = false
        this.onFocusScItemId = null
        this.onFocusScItemTenantId = null
        this.onFocusScitemMerchantCode = null
        this.itemAeSelectedRowKeys = []
        this.itemAeSelectedKeyMap = new Map()
        this.shopAeSelectValues.splice(0, this.shopAeSelectValues.length)
        this.itemAeSearchdata = []
        this.innerAeSkuData = new Map()
        this.paginationAeItem = {
          defaultPageSize: 10,
          current: 1,
          pageSize: 10,
          total: 0,
          onChange: current => {
            this.paginationAeItem.current = current
            this.onItemAeSearch()
          }
        }
      },
      pdpUrl (pdp) {
        window.open(pdp)
      },
      subDetailRelation (record) {
        const site = record.site != null ? record.site : record.itemSite;
        request({
          url: '/item/' + site + '/' + record.itemId + '/' + record.skuId,
          method: 'get'
        }).then(response => {
          var itemData = response.data.data
          console.log(JSON.stringify(itemData))
          this.platformTitle = itemData.title
          this.platformShopName = itemData.sellerId
          this.platformSellerSKU = itemData.cbSkuBos[0].sellerUniCode
          this.platformMerchant = itemData.merchantCode
          this.upShow = 'none'
          this.downShow = 'none'
          //LAZADA 商品状态逻辑
          if (itemData.cbSkuBos[0].skuStatus == 1) {
            if (itemData.merchantCode == 'LAZADA') {
              this.upShow = 'none'
              this.downShow = 'block'
            }
            this.platformStatus = 'normal'
          } else if (itemData.cbSkuBos[0].skuStatus == -1) {
            this.platformStatus = 'delete by seller'
          } else if (itemData.cbSkuBos[0].skuStatus == -2) {
            this.platformStatus = 'downShelf'
            if (itemData.merchantCode == 'LAZADA') {
              this.upShow = 'block'
              this.downShow = 'none'
            }
          } else if (itemData.cbSkuBos[0].skuStatus == -3) {
            if (itemData.merchantCode == 'LAZADA') {
              this.upShow = 'block'
              this.downShow = 'none'
            }
            this.platformStatus = 'downShelf by admin'
          } else if (itemData.cbSkuBos[0].skuStatus == -4) {
            this.platformStatus = 'delete by admin'
          }

          if (itemData.itemStatus == 1) {
            if (itemData.merchantCode == 'AEGDCHAIN') {
              this.upShow = 'none'
              this.downShow = 'block'
            }
            this.productStatus = 'normal'
          } else if (itemData.itemStatus == -1) {
            this.productStatus = 'delete by seller'
          } else if (itemData.itemStatus == -2) {
            this.productStatus = 'downShelf'
            if (itemData.merchantCode == 'AEGDCHAIN') {
              this.upShow = 'block'
              this.downShow = 'none'
            }
          } else if (itemData.itemStatus == -3) {
            if (itemData.merchantCode == 'AEGDCHAIN') {
              this.upShow = 'block'
              this.downShow = 'none'
            }
            this.productStatus = 'downShelf by admin'
          } else if (itemData.itemStatus == -4) {
            this.productStatus = 'delete by admin'
          }

          this.platformSku = itemData.cbSkuBos[0].groupUniCode
          this.platformCategory = itemData.categoryId
          this.platformBrand = itemData.brandId
          this.platformMainImage = itemData.cbSkuBos[0].majorPictureUrl

          this.upDownBody.itemId = itemData.itemId
          this.upDownBody.skuId = itemData.cbSkuBos[0].skuId
          this.upDownBody.sellerId = itemData.sellerId
          this.upDownBody.site = record.site

        })

        this.subVisible = true
      },
      subDeleteRelation (record) {
        // alert(record.sellerSku)
        request({
          url: '/relation/delete',
          method: 'post',
          data: {
            itemId: record.itemId,
            skuId: record.skuId + '',
            sellerId: record.sellerId,
            itemTenantId: record.itemTenantId,
            itemMerchantCode: record.itemMerchantCode,
            tenantGroupId: record.tenantGroupId,
            scItemId: record.scItemId,
            scitemTenantId: record.scitemTenantId,
            scitemMerchantCode: record.scitemMerchantCode,
            cbShipperId: record.cbShipperId,
            shipperId: record.shipperId
          }
        }).then(response => {
          if (response.data.success == true) {
            this.successAlert('Success')
            this.onList(record.scItemId)
          } else {
            this.warningAlert(response.data.errorMsg + '[' + response.data.errorCode + ']')
          }
        })
      },
      editClick (e) {
        this.startEdit = false
        this.editVisible = true
      },
      editCancel (e) {
        this.startEdit = true
        this.editVisible = false
      },
      handleExportClick (e) {
        if (e.key === 'import') {
          // this.outboundFrom.ids = ''
          // this.$refs.exportAlert.exportFile(this.outboundFrom, 1012)
        } else if (e.key === 'export') {
          this.productExport.shipperId = this.tableSearchShop
          this.productExport.cbShipperId = this.cbShipperId
          console.log('tableSearchShop:' + this.tableSearchShop)
          console.log('productExport:' + this.productExport.shipperId)
          console.log('productExport:' + this.productExport.cbShipperId)
          this.$refs.exportAlert.exportFile(this.productExport, 1011)
        }
      },
      successAlert (msg) {
        this.$message.success(msg)
      },
      errorAlert (msg) {
        this.$message.error(msg)
      },
      warningAlert (msg) {
        this.$message.warning(msg)
      },
    }
  }
</script>

<style>
  .ant-table-tbody > tr > td {
    border-bottom: 0 solid #ffffff;
    -webkit-transition: background 0.3s;
    transition: background 0.3s;
  }

  .once {
    border-bottom: 0 solid #ffffff;
    background: rgb(255, 255, 255);
    height: 35px;
  }

  .twoe {
    border-bottom: 0 solid #ffffff;
    background: rgba(227, 246, 255, 0.38);
    height: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Item/ScItemView.vue